import api from './api'

export const quickOrderService = {
  submitOrder(slug, payload) {
    return api.post(`/public/restaurants/${slug}/quick-order`, payload, { skipAuth: true })
  },
}
